/* eslint-disable */
export default {
  region: 'Région',
  calling: 'Appel en cours',
  logout: 'Déconnexion',
  version: 'Version',
  settings: 'Paramètres',
  selectToDialSMS: 'Sélectionner pour appeler/envoyer un SMS',
  selectToDial: 'Sélectionner pour appeler',
  selectToSMS: 'Sélectionner pour envoyer un SMS',
  clickToDial: 'Cliquer pour appeler',
  autoCreateLog: 'Créer automatiquement un journal des appels',
  autoCreateSMSLog: 'Créer automatiquement un journal de SMS',
  autoLogCalls: 'Enregistrer automatiquement les appels',
  autoLogNotes: 'Enregistrer automatiquement les remarques',
  autoLogSMS: 'Enregistrer automatiquement les SMS',
  clickToSMS: 'Cliquer pour envoyer un SMS',
  logSMSContent: 'Enregistrer le contenu des SMS',
  clickToDialSMS: 'Cliquer pour appeler ou envoyer un SMS',
  logExtensionCall: 'Journal des appels d’extension',
  audio: 'Audio',
  language: 'Langue',
  feedback: 'Commentaires',
  userGuide: 'Nouveautés',
  quickAccess: 'Paramètre d’accès rapide',
  report: 'Rapport d’analyses',
  shareIdea: 'Partager une idée',
  openEntityFrom: 'Comportement des objets Salesforce',
  ctiPanelSize: 'Taille du panneau CTI',
  openInNewTab: 'Ouvrir dans un nouvel onglet',
  openInCurrentTab: 'Ouvrir dans l’onglet actuel',
  reportIssue: 'Signaler un problème',
  contactSupport: 'Contacter l’assistance',
  selectToDialHint:
    'Pour une meilleure expérience, sélectionnez le numéro de téléphone à composer avec RingCentral sur la page des numéros de téléphone en grande quantité.',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
